import { FilterOperator } from '../../api/api.operators';
import { FilterData } from './filter.interfaces';
import { TextFilterComponent } from './text-filter/text-filter.component';
import { MultiselectFilterComponent } from './multiselect-filter/multiselect-filter.component';
import { of } from 'rxjs';

export function stringFilters() {
  return [
    FilterOperator.EQ,
    FilterOperator.LIKE,
    FilterOperator.NULL,
    FilterOperator.IN,
  ];
}

export function dateFilters() {
  return [
    FilterOperator.GT,
    FilterOperator.GTE,
    FilterOperator.LT,
    FilterOperator.LTE,
    FilterOperator.BTW,
    FilterOperator.EQ,
    FilterOperator.LIKE,
    FilterOperator.NULL,
    FilterOperator.IN,
  ];
}

export function dateNotFilters() {
  return [
    FilterOperator.BTW,
    FilterOperator.EQ,
    FilterOperator.NULL,
    FilterOperator.IN,
  ];
}

export function booleanFilters() {
  return [FilterOperator.EQ, FilterOperator.IN];
}

export function enumFilters() {
  return [
    FilterOperator.EQ,
    FilterOperator.NULL,
    FilterOperator.IN,
    FilterOperator.CONTAINS,
  ];
}

export function enumNotFilters() {
  return [
    FilterOperator.EQ,
    FilterOperator.NULL,
    FilterOperator.IN,
    FilterOperator.CONTAINS,
  ];
}

export function numberFilters() {
  return [
    FilterOperator.GT,
    FilterOperator.GTE,
    FilterOperator.LT,
    FilterOperator.LTE,
    FilterOperator.BTW,
    FilterOperator.EQ,
    FilterOperator.LIKE,
    FilterOperator.NULL,
    FilterOperator.IN,
  ];
}

export function numberNotFilters() {
  return [
    FilterOperator.BTW,
    FilterOperator.EQ,
    FilterOperator.NULL,
    FilterOperator.IN,
  ];
}

export function createStringFilter(
  data: Partial<FilterData> & Pick<FilterData, 'name' | 'label'>,
): FilterData {
  return {
    component: TextFilterComponent,
    ...data,
    extraInputs: {
      appFilterOperators: stringFilters(),
      appFilterNotOperators: stringFilters(),
      appFilter: data.name,
      ...data.extraInputs,
    },
  };
}

export function createNumberFilter(
  data: Partial<FilterData> & Pick<FilterData, 'name' | 'label'>,
): FilterData {
  return {
    component: TextFilterComponent,
    ...data,
    extraInputs: {
      appFilterOperators: numberFilters(),
      appFilterNotOperators: numberNotFilters(),
      appFilter: data.name,
      ...data.extraInputs,
    },
  };
}

export function createEnumFilter(
  enumInfo: { type: any; labels: Record<string, string> },
  data: Partial<FilterData> & Pick<FilterData, 'name' | 'label'>,
): FilterData {
  const items = Object.keys(enumInfo.type).map((enumKey) => ({
    id: enumInfo.type[enumKey],
    label: enumInfo.labels[enumInfo.type[enumKey]],
  }));
  return {
    component: MultiselectFilterComponent,
    ...data,
    extraInputs: {
      appFilterOperators: enumFilters(),
      appFilterNotOperators: enumNotFilters(),
      appFilter: data.name,
      searchFn: (search: string) =>
        of({
          items: items.filter(({ label }) =>
            label.toLowerCase().includes(search.toLowerCase().trim()),
          ),
          hasNextPage: false,
        }),
      ...data.extraInputs,
    },
  };
}
export function unpackFilterValue(tokens: any): any {
  if (tokens === undefined) {
    return undefined;
  } else {
    if (
      tokens[0] === FilterOperator.NULL ||
      (tokens.length == 2 && tokens[1] == FilterOperator.NULL)
    ) {
      return null;
    } else if (tokens.every((token: any) => Array.isArray(token))) {
      // Multiple filters were applied, return values as array
      return tokens.map((filter: any) => unpackFilterValue(filter));
    } else {
      return tokens[tokens.length - 1];
    }
  }
}
